module.exports = __webpack_public_path__ + "static/media/bg-superiority-2.56c87b81.png";